if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
  this.querySelectorAll(
    `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
  ).forEach((element) => {
    element.classList.remove('active');
  });
  const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
  const activeMediaTemplate = activeMedia.querySelector('template');
  const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
  activeMedia.classList.add('active');

  // Fjern scrollIntoView og sæt manuel scroll til top
  const container = this.querySelector('[role="document"]');
  container.scrollLeft = 0;
  container.scrollTop = 0;

  // Tving billede til at fylde containeren korrekt
  const img = activeMedia.querySelector('img');
  if (img) {
    img.style.position = 'relative';
    img.style.width = 'auto';
    img.style.height = 'auto';
    img.style.maxWidth = '100%';
    img.style.maxHeight = '90vh';
    img.style.objectFit = 'contain';
  }

  if (
    activeMedia.nodeName == 'DEFERRED-MEDIA' &&
    activeMediaContent &&
    activeMediaContent.querySelector('.js-youtube')
  )
    activeMedia.loadContent();
}
    }
  );
}
